module.exports = __webpack_public_path__ + "img/kjcg-kjcg.77f8e5c9.jpg";